import DetailsContainer, {
  DetailsVariants,
} from 'pages/terms-and-policies/header/DetailsContainer'
import DetailsFieldLabel from 'pages/terms-and-policies/header/DetailsFieldLabel'
import DetailsFieldValue from 'pages/terms-and-policies/header/DetailsFieldValue'
import { TermsAndPoliciesContactPerson } from 'pages/terms-and-policies/header/TermsAndPoliciesContactPerson'
import { PolicyDocument } from 'pages/terms-and-policies/models'
import React from 'react'

type TermsAndPoliciesCompanyDetailsProps = {
  item?: PolicyDocument
}

export const TermsAndPoliciesCompanyDetails = ({
  item,
}: TermsAndPoliciesCompanyDetailsProps) => {
  return (
    <DetailsContainer variant={DetailsVariants.Dark}>
      <div className='flex flex-col justify-start items-start gap-2'>
        <div className='flex justify-start items-center gap-1.5'>
          <DetailsFieldLabel
            variant={DetailsVariants.Light}
            text='Company Name:'
          />
          <DetailsFieldValue
            variant={DetailsVariants.Light}
            value='Legal Utopia Limited'
          />
        </div>
        <div className=' flex justify-start items-center gap-1.5'>
          <DetailsFieldLabel
            variant={DetailsVariants.Light}
            text='Company No:'
          />
          <DetailsFieldValue variant={DetailsVariants.Light} value='10909418' />
        </div>
        <div className='flex flex-col justify-center items-start gap-1.5'>
          <DetailsFieldLabel
            variant={DetailsVariants.Light}
            text='Registered Address:'
          />
          <DetailsFieldValue
            variant={DetailsVariants.Light}
            value='3rd Floor, 86-90 Paul Street, London, EC2A 4NE'
          />
        </div>
      </div>
      <div className='h-[0px] border border-[#f4f4f4] w-full' />
      <TermsAndPoliciesContactPerson
        variant={DetailsVariants.Dark}
        author={item ? item.author : null}
      />
    </DetailsContainer>
  )
}
